// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"78dc45c5","213":"f59ef034","239":"2fa27016","453":"fd7adcb7"}[chunkId] + ".chunk.js";
};